var _defs, _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "350px",
    height: "500px",
    viewBox: "0 0 210 297",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    style: {
      display: "none"
    }
  }, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 210.26508,
    height: 275.45242,
    preserveAspectRatio: "none",
    href: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAQDAwQDAwQEAwQFBAQFBgoHBgYGBg0JCggKDw0QEA8N Dw4RExgUERIXEg4PFRwVFxkZGxsbEBQdHx0aHxgaGxr/2wBDAQQFBQYFBgwHBwwaEQ8RGhoaGhoa GhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhr/wAARCAC3AIsDASIA AhEBAxEB/8QAHAAAAgMBAQEBAAAAAAAAAAAAAAYBBAUHAwgC/8QAQRAAAQMDAgMGAwUGBAUFAAAA AQIDBAAFEQYSEyEyBxQxQVFxFSJCI2FygYIIFlJikaFDRKLBJCUzNqNTg5Kzw//EABoBAAIDAQEA AAAAAAAAAAAAAAACAQMFBAb/xAAyEQABBAEDAgUBBQkAAAAAAAABAAIDEQQSITEFQRNRYXHwIhQy gaHxFSMzQmKRscHh/9oADAMBAAIRAxEAPwD737wn0VR3hNVz1GoqjWU9BWe8Jo7wmq1FGsooKz3h NHeE1Woo1lFBWe8Jo7wn0VVaku/39abq7DTOet0OOptpxyLFL8h+Qsbw02Nq+lsb1EBRo1lFBPve E+iqO8J9FVzOfPWxHTJh3HVDUdKsPSHYqEpZH8S0vtpUpOfJNN2nbk9dLfvmNhqdHdXGktjwDiDt JH3K60/cqjW5SQFvd4TR3hNVqKNZUUFZ7wmjvCarUUayigrPeE0d4TVaijWUUFZD6VHwNetUkdY9 6u1Y02Ep2VI9RqKk9RqKoKdFFFFCEUUUUIUGkKxQVuas1BcZRUubGkLbRCHLaHEtpS7knB3Nspwf I8VNPu4Unasc7herLOtLSJN5LpZMZCwlcmIQSseyTtWCeWfl+uhSExrWiYwpp+LxGVqW04h1IwUj l4HxBpe0HFZjqvrlu3qtbs/bEWtZUVBppDSsZ+kLbwKyb/eHZFpmtW60XGE1IUhufKeimPwGFKw6 sea1AKUcjcB40+W8Q0QowtfA7mG0hjgY2bPLbjlioCYq1RUbhU1KRFFFFCEUUUUIUo6x71dqkjrH vV2rY+EpVI9RqKk9RqKqKZFFFFCEVVuUxFtgSpb+eHHZU6vCcnAGatUv65CTozUIX0Lt76D+aSKP ZSOUpXW+3mQ0ZUiSIsFlJcfiQ/kWQOZHGJJ5D0Cc08Wqz2+2ILltjIbU8AtbnMrcz5qUrJV+dZX7 kW9Y4Tr0t2JnBjLWCggfSTjcR7mmgchWRgMzY2uGW8ON7V5LqmMLiPCFL87aRNWQItsfjfBWzarh OWomTEUW8BPMkpHyrUc/UKfCaoXSzxbuwlqcgq2K3NrCilTavDKSPA12TtldE5sTqcRsfIqthaHg uFhLlj1LLF3iW66Ook99Cww5sCV7kJ3EKxgHIFOtJUmwQbVe9PS2uIt/v6m+K6vcQlUd4bR6AmnW kwY8iLHa3Idqf3KJ3RueTGKCKKKK7lQiiiihClHWPertUkdY96u1bHwlKpHqNRUnqNRVRTIooooQ ilnXrrI0vOZkKDaJBbj5P86wmmaufasmLd1EhDUaVKahRRxlssFYYU4fl5JySVAc8eFcuVM+CB0j G6iOw7q2JgkeGk0ruqtSSe58PSj7D0osPyy7gOIDbQyU+6llKKb2HEvsNuI6FpCx7GuYaWcTcNSX 6YIb8WNFtgjuvyGy2XVrJXgJVg/Kgcyf40086TW6vSliMgFDht8feFeIPCGajHldNA2R7dJI4KZ7 Qx5aDa2aXNVPzwLZEs0hMadMklCHFgKHyNOOYOQeSijBpiJpdvn/AHBpZShyEp8Z+8x3K6ByqysW 8aohTrTZ5SSG5KJ0R9yP4qZHFCXN2M42jdkmnxtxLqEqaIUgjIKVZBFcStaplouF6sztluLr7Fxf cbkRGOIiSl1ZdQrIPynC8HdtGUV0rQ7zgs7kSYz3WZEkONusbtwb3HiJwR4jYtNZ2LlZEuRJHJFp a3g+fznZXyRMYxrmusnsmaiiitRcqKKKKEKUdY96u1SR1j3q7VsfCUqkeo1FSeo1FVFMiiioNClC yAPmITSZbrumFpuXfOEX5N1kqfjMeCnSshDCPuygNVy3tf7afgOoI1kmW6SnTyytMqa2Ae8lJwpp PqkHkutrsi7QJnac/Fm3a1/DI0HjfD9vQ+oYTv8AdCFYrlGTCZfDDt/m3v8APbUf0rNiwxmujIiP Dtq77c87GxVjk0CCXq5Wtds0e/b1Phc+5upYkPhOC44+sIcWB5YBVgeQRTagJSgBA2jyFYupE8SR p5v1uqD/APFl1f8AtW3trocswIrB1g2sWJ6W1/1LctE4Y8cNKC1D9SAoVvVVuMcS7dLjq6XmVtn8 04pVJWNqAGA6xqOAkud1bxMQhOS7E6j7qR1p/Un66FyG4WqIU1Dg7pdo/divd8vERlbWPxILtX9L u950vZ3fNyAwT7lAr5f7Qe1+56Mu83TTttQvTXDd+GYIDpws7SVHOEpWFBONpApJ5o8dup5Wh07p uV1Wf7Pit1Pq6sC68rqz6e/kV9ceNFci7E9e3zUVmt0bWjTaJ8mIqTEfR4yWklCSpYHgr7RNdcBB p45Gyt1NNhcU8L8eV0T+WkjbcbeR7j1U0UUVYqVKOse9XapI6x71dq2PhKVSPUaipPUax77f49jj tl0oclPucOPH3hJdXjOB7AZPoKoe5rGlzjQCdrS40Fr0rTLtLvrq4emXUoaQotyLp1IbwcFLQ8Fu f6Enx3dFUYTkrV0qXGvLndYbG09yjOH7dJB5rc5EpPhsAT96lU3sMNxWm2Y7aGm20hCEITgIA8AA KrjlZMwPjNg8FOWFpp3K+fO0H9niTqHUUOVDuMqZYUBZctzsra624rmpaFqCgdyzlWa2ew7s7ueg LrcbdfLiJnAjIfhsIOUsJdccSr8zwa7dWFZEJf1BqOV9aHo8P9KGQ4P7vqqpuPF4niad/m/z9dKT qmbJhtwnSExjhu1Dn053O/J4JIAAnUnySdOuq6G7qnP6mXkD+663qwtZqLGnJUpKNxgqamfk0sOH +wrbTXSVmBJ9gcV+/wDrFtTaEoLcLYQnmcNHdn23ppuccS02pxfQgFZ9hSTZxjXdwdTnc6mWFfoM QJpg1W+Y+m7utJ2rMN1Df41J2p/uaXuhRo9CkaQsYUNqu4MHHplAriuouwO3as1rqW6OKDvEcDIi uSFNBsqbQoupUArzWrCa+gIcdMOMzGb6GG0tj2AxWI0FMa0mj/Dl2xlz9Ta1pJ/otNLNE2ZulwXT i5mRhPMmO8sdVWDW3l+QSN2f9isXR1majTLi/JuDGe7S2VFJiZOSWt2eo9XkQlI207RtQP2txqFq lLbDhIbantpKYz5PIDmTw1n+En2UqmGvKTHalsOMyG0OsuAhba05SoHyINSwCMaWigqppHzyOkkN ucbJ8yVZornLkufYrxJh6fkf8vjhAMeUkuJSsgK2tqyClIB8Pm6uVNWmtUQ9Sw1PRSpp5s4fjuJ2 raPoR6HyPgapiy4J5XxMdbmchK+J7GhxGxW6jrHvV2qSOse9Xa0WcKgrGulwYtcCTMmK2sspJO1O SfQAeZPgBSJdrU+w3AvV5bCrm/JAkq3ZEVCkrCGkn+EEpB9SvdS9J1D8TkqOoHXGrh3xwwobKlEo UhRCQ2lOQpxP1Vu311SdLu3LtGkM26EI4AtxdADjxTgBxQ61E+CE/KKxXPHUWTY2ktrayOfZdjWu hcx439AtPS+XNQSijoahhLn4lKyke+EKp0Ipa0W/a/hCYdtlRJMuEEMXDuywsiSEDfvx9VMnKmwc X7FjMgu6/VE0niSFxFIrE08jZdNT/wA1xQf6xWK2jzFYuk/t41xn/TOuDzqD6oSQ0g/mG81oNXOV sy4zc2M9GfAU0+2ptYV5hQwa+cpv7SydKSfgt3tL6nYMBA70rwmOgYygDwQryVX0kRXybeP2fr3r iYbt8WMqzPR1Jsze8BTDeSGgsK8U7NpJHM1zZRnDP3IF/OPn+1u9Db0t+UR1QkR0fu3d7VVA+vO1 X3oHfb7XposUjWln0++/MfYlOGEtXJjIiDiK8Cpv5FEEV46b7e5fafqW02Bmx8C2uOxnZsjiHLS0 vIX7bCU7K8Fdk12m9nFotLt6cdvUqdItkhxTqgjY0XMITyyUp7vyBq1prsIZ0Nqqwag40qLAYfZY kxlyAVPOqUEoWSnls4m3Ka5nPzPGaCBXt6d/+fgtKP8AYAxMkPBMtu8MjVVdr4v+mxd7v2oL6XrB fONYRh62t788Ot1vUvX9Xc7xYbgro464Tns8OX/kbaFaZXjwaW7UGvyH2152KCtpxyqeIkDKiE1W nXONRyWLHdrm9dHkRYz5ElDri8AgIQlQ9wUeFXLXapLOnbZeLc2FXaOhx8Npx9s044XFME/q+X0V VHtU7RdNabYFlvVwEW4SGBNjpWhRSeE4FhJI8NxRgVMJuNrbS7V57PpKmLfc8OPRH0FLTmHMupx/ hrOFJUR8qqzIMGPFnmyWG3O3rb3/ADXdKJ3QRl7CGdnUaP41R4PB7FdBs13h3uGzMtr6H47ngQrm PUEeRHgRW3XFbS3dlaxtIjW+4WrurpRJ4rWEPNYIwSnKSkeKeec7cV2qtTCmknhD5GFhPYrPmY1j 6abWSi3xWpDj7UZht9zrdSgBSvc+Jrjv7R8FWodJtWG1swZV2dfS+EyZCGlR2U5K3wVEADyJPrXa l+Jr467etGak1frq8XfTdlkO2yJEKZExDoCXQzhLifdJTUTEiM00u7V77Lb6FGx/UYy6YRaTqDnc Atoi9xyduffbVWp2YaZvfZ1GfZv0Zm2MvSDxH40jdJlsEYSsoQSoNJXt+YV0SPq9py6yLf8AEJqL cy0CHFLWlBd8VJ4x58kFo4zj56+Z9X6UvsGendar1DiMQ4rsxlyWFfKoktoZ9QhB2AfMRsUTX71B qq9xNWPuwb1qFm0vPxi++sEOtpOzZtI6jw0Jwr66wMjEY57tL5G0Kobjfe/n6+od0+XqcrZzNG58 oLz2qqFGifqP8oGx2Aq9Lfpi36lNxduBlPXV9mKrMZxCHjmP4bk7OZPEQ6Ofz/JXUNINFjTFoaUA nZFaGE+m0VyG2SI+Iq1tT7q1KjK7tJbirf4yUvublLQ2nkd73iRXV9DumRpa2O4KWnGt0dCvFDJP 2aT94RV3TmlmRIPrIIbu7jjt6+a8Tkm428fgtqZnuj+zq4Sse+Kx9G7f3P0/s6PhkbHtwhW8aXdH gMWty3pGxNtluw0D0bSr7P8A8ZTW47hcQS7GB77ZWuW1vVVwP9WpSv8AemLWm393JJUOYcZWj8Qe QU/3rDaSGNE2yfj7VFxbn7vEguysrx7ocUK3dUIEk2eAr/N3Nkn2ay//APjQeUJjPUaWO0EK/c+6 uNtcfgIS+W/AuBCgspScjCiBhJ8jTNSn2ipfOl3zHbS+hDzJfjqwOM1vAUj5uXP7+VLJ/Ddtex/w UN+8Fzi5zTCmwG02uW1FeViUGkgb8kNpSUJzxBxCmqruoWId9cauMWVGs6EhttclPDbTKOCRwV4U CoONYOKVO2O1Tp2m5Hw+y3BiVHXGC2mkhCyXVkNKISTuSlaFD3XXPIektS3zs11M5Itky4TWrww/ IkyHyoEhC0qcb9SAtO6vKY/TmSxDU2RpLTtq9b/v8pexx8WKeETvyGNGsNqhdGgXbkfSL379u9jd 7YdNKvbd0uTF1bfYsZV3u0BG6RFOAgbFAEFAJSVpBw3vrrP7OHaBGven29LN8WVIssZJM0N7WnEq OQgZwQU5xXLdGdlV/maV1dpy8QHrbNfSZcOapCguWplYCsBWFbSHsfTnfXSeyzs0X2aXSJdolz71 ZruptkRwsrSgOIyl3cUp5laUjG2t+CPw9BY3Yjezvtx8pTnZOJ9glwXzF7on3FQphBrUdhyd6s9v qogBd/QBvBq7VJHWPertazOF4k8qivxNKbul5ripEFUlhVkkzVSnUbTxSFK4imvTapfifTlTaeo1 FUpkjXOQ9Bk6oQWZCpkoNIt4SwpQXlkJG0gYwlzcVegq3e7NEhRNNlcTvka1yWw4hLBcOzgraCto BJ2laSfQU2kA+VG0Ud1NpHs9gunwezy4EhFsuCGXw4iTFLg2vOcTBTuQQpJ2022q3t2q3RYEfKmY rKWkE+JCRgE1bAAqaFCKVYUtECXq6Q66EsMTA6s+SMRWFGrU69yJMl236dbQ/Mbwl+Q7ngRcj6sd S/5B+ak16Q9PtRrXJgrcVIMviGS651PLWMKUcf2HkKgpgFlOQHkdmTUbhnvbdnQdm3nxEtBWPfIr 2uMtmfe9HS4yuJGeeecbWPA7ozhSfzFVjcXXOzQvbz3v4YY5Pge8AcL/AOytudYI8u2MwQpxhMcI 7u4zyWypHSpPtQaQFs1Tu1tau9slwJW/gyGlNr2KwoA+YPkRWNHvsq1SG4mqA23xFBDFwa+Vl5R5 BKgc8NZ8gSoHyVTLUpUn3TTkmPbLhJYdcud1ccjvArSlJXwFhaEJAwB9X5rqxaLUu4Wm8tXRlbSL rIfVwl9QaUNid3oSgZIpoowKEJMtibtLmWI3OG6xJgMOCe+VJCHFlAT8mCSQojeK0I2kmIsllaJM nujElcpiEVJ4TbivHHLOASogE4BVTHgUUIUo8R71dqkjrHvV2rY+EpVI9RqKk9RqKqKZFFFJDs2V qd0cB95i1LJ4LbDhbdlgHBWpfi216Y5qoQt2fqWLGkriQw5cpqOuNESFqT+MkhKP1FNVTb7xeVA3 eQLZE840JZK1fif5EeyQn8VaVsYgRWDFtbLTEdg42MowgHzx/vWgOmlJThVocOPb4zcaAyiNHbGE NoTgCvfdU4pbuc+Xc55tFjWpnYf+Ompwe7AjIQjPi6f9I5moAtSsdwIasUuMlY4A1KhH3YXObWR/ VeKe6z2tP29m0fChGSqAUlC215VvzzUSTzKiTknxJrKiSpWn5yLfd3nJMCQoIgzHFZUFf+i6rzUf pUerwPzUxFpQUwyYzMtpxmQ2h9lxJSttaQoLB8QQaw02KXaCDpuaWo4/yUrLrHsg9Tf+oD+GmEio pQaU0sFOqDAwjU0Jdp8AZG7ixST6PDGP/cCK323EOALQsKSRkEcwRVWTLaaY4qgXG/AlCd2B6nHl Sk4w/p5xcmwoShnBeVBaV9hJbHNRaH+G75+iqkFQnqivGJJamxmZMVYcZebS42seaSMg17UyVSjr HvV2qSOse9Xatj4SlUj1GoqT1GoqpMoIBGFUiBEzScZ2NPbW7bRw47FwZ5FiMDtAdHiNoPWNw+o7 afKggEYVQpCw23YdxJQw8yq2xEpzw1goWSN2CR9IFXYa3pA7w6Q2wR9m3t548QpR9T6VlXPRsaUJ K7Q+7ZZMhBS65DSkJc/GhQKVe/jX7cY1JIjIjuOW6EtfyuyWVqWQn1Q2pGAr3KgKirTBed0uci4T HLPYVhMkAGTMCdyYiT78i4fpT5dRrZtlsjWiE3EhNlDaP4lFSlKPMqUo81KJ5knmTX5tFpjWeGiN Db4aASslSipS1HmVKUealHzJq/QBSUlFVp8CPcYjsWa0h+O8nYttXgRVmipUJVjTZGnZLVvvLhdh OqCYc9f9m3j/ABeSV/V+Kt6U28tIchuhLqM/Ivpc+4+Y9xXtLiMzY7rEppt9lxJQttxOUrB8iDWA 3ar5ax3a0TYsmFn7MT96nGR6BSesDyztP81KQmX6lXODbGmbq46iHEfWlqQFqCRuJ2gn+YHkay+7 TdTMuR4QXb7N3glMspKXnEEfMGkkDak5UAs+Xgmtm06Vi29xEmY47cLgCtZkPrUQFqJKi2jJSjx8 q3QMVNItfhhhuOw2yw2Gmm0hCEJ5AAcgBXpRRUpVKOse9XapI6x71dq2PhKV5cBNHATRRT6Qoso4 CaOAmiijSEWUcBNHATRRRpCLKOAmjgJooo0hFlHATRwE0UUaQiyjgJo4CaKKNIRaOAmjgJooo0hF lHATRwE0UUaQiypDCQa9KKKkClC//9k= ",
    id: "image2425",
    x: 0.53092897,
    y: 11.844707
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6297",
    style: {
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.98251964,0,0,0.9942622,3.5669035,-0.58404046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5587",
    style: {
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 107.46642,51.997845 c 0,0 -0.82036,4.101772 0.18931,5.742479 1.00967,1.640711 4.66971,3.15521 7.69871,3.660042 3.029,0.504836 8.70838,1.76692 10.28598,2.650377 1.57761,0.883459 4.03867,3.029 4.29109,4.732813 0.25241,1.703814 -0.12621,10.033564 -0.0631,12.557731 0.0631,2.524167 0.69415,4.543502 1.19898,7.193878 0.50484,2.650376 0.82036,4.606605 1.13588,5.426959 0.31552,0.820353 1.26208,3.975563 1.95623,5.363855 0.69414,1.388291 3.84935,7.256981 4.66971,9.781151 0.82035,2.52416 1.89312,7.69871 2.96589,9.52873 1.07278,1.83002 3.1679,5.62524 5.12412,6.76112 1.95623,1.13587 4.07959,3.91582 6.3999,6.41462 2.32031,2.4988 6.87169,6.24699 8.83504,7.40715 1.96334,1.16016 9.48922,7.49847 12.83374,9.01297 3.34452,1.5145 6.24731,2.71348 7.82492,4.03867 1.5776,1.32518 4.73281,4.03866 6.43662,6.18421 1.70382,2.14554 4.10178,5.11143 5.30076,6.43662 1.19898,1.32519 5.04834,4.10178 6.43663,5.42697 1.38829,1.32518 2.71347,3.1552 2.90279,4.16487 0.18931,1.00967 -0.56794,2.46106 -1.4514,3.15521 -0.88346,0.69414 -5.42696,0.63104 -8.14044,-1.19898 -2.71348,-1.83002 -3.72315,-3.72315 -5.55317,-5.17455 -1.83002,-1.45139 -5.86868,-4.22798 -7.06767,-4.16487 -1.19898,0.0631 -2.27174,1.19898 -2.27174,2.77658 0,1.57761 4.18018,9.74156 5.18985,13.55209 0.72643,2.74158 3.12458,7.99257 4.32356,11.65262 1.19898,3.66004 2.49803,6.50422 2.62424,8.96528 0.12621,2.46106 -0.82221,4.38667 -2.71534,4.38667 -1.89312,0 -4.25412,-3.17052 -5.64241,-5.7578 -1.38829,-2.58727 -2.88113,-7.52471 -3.8908,-8.78679 -1.00967,-1.26208 -3.59203,-8.88091 -5.39262,-7.81933 -1.97382,1.16371 -0.30207,4.31612 -0.17586,5.38889 0.12621,1.07277 0.94656,3.40763 1.95623,6.058 1.00967,2.65038 1.76691,5.86869 2.08243,7.69871 0.31553,1.83002 0.50484,4.92213 -0.0631,6.68905 -0.56794,1.76691 -3.66004,1.70381 -3.66004,1.70381",
    id: "path2464"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 174.04134,213.60765 c 0,0 -2.20866,-0.56794 -3.02901,-3.15521 -0.82036,-2.58727 -0.88346,-2.58727 -1.26208,-4.35419 -0.37863,-1.76692 -0.36781,-2.55664 -0.88346,-4.6066 -0.40641,-1.61567 -1.25761,-3.80157 -1.57313,-5.50538 -0.31552,-1.70381 -1.64519,-3.83404 -2.08692,-5.03302 -0.44173,-1.19898 -0.68332,-2.70714 -1.75609,-2.77024 -1.07277,-0.0631 -1.07911,0.81401 -1.14222,1.94989 -0.0631,1.13587 0.0325,4.6264 0.0956,6.51952 0.0631,1.89313 -0.006,5.63345 -0.0848,7.67892 -0.0753,1.96393 0.17847,4.29108 -0.26325,5.74248 -0.44173,1.45139 -1.55146,3.66004 -3.19217,3.72314 -1.64071,0.0631 -3.37515,-2.71348 -3.31205,-5.04833 0.0631,-2.33486 -0.25241,-4.35419 -0.0631,-6.12111 0.18931,-1.76692 -0.12621,-4.98523 -0.0631,-7.25698 0.0631,-2.27175 0.18931,-4.41729 -0.0631,-5.74248 -0.25242,-1.32519 -0.5049,-2.14527 -1.26208,-2.33485 -1.73892,-0.43539 -1.85616,1.35132 -1.79305,2.42409 0.0631,1.07277 -0.37863,4.12792 -0.50484,5.89484 -0.12621,1.76691 -0.4787,3.54465 -0.5418,5.18536 -0.0631,1.64071 -0.74009,4.70668 -1.30802,5.96876 -0.56794,1.26209 -1.61009,2.29789 -3.25079,1.98237 -1.64071,-0.31552 -2.361,-1.83636 -2.61341,-4.10812 -0.25242,-2.27175 -0.33718,-3.52749 -0.21097,-5.29441 0.12621,-1.76691 0.25242,-6.24731 0.44173,-7.76181 0.18932,-1.5145 0.25242,-3.40763 0.31552,-4.66971 0.0631,-1.26208 0.25242,-4.03866 0.25242,-4.03866 -0.12621,-0.94657 -2.83969,-6.18421 -3.28142,-9.97047 -0.44173,-3.78625 -1.13588,-14.32465 -1.5145,-17.60606 -0.37862,-3.28142 -1.5145,-9.52873 -1.64071,-10.98013 -0.12621,-1.45139 -0.94656,-8.96079 -0.88346,-11.29565 0.0631,-2.33485 0.44173,-3.0921 -0.69414,-5.9949 -1.13588,-2.90279 -4.60661,-10.41218 -6.94146,-13.44119 -2.33486,-3.029 -5.11144,-8.26664 -5.61628,-9.21321 -0.50483,-0.94656 -1.00966,-3.66004 -0.94656,-4.985225 0.0631,-1.32519 -0.63104,-4.164878 -1.26208,-5.616273 -0.63104,-1.451396 -1.89313,-5.805586 -2.71348,-5.931792 -0.82036,-0.126209 -1.32519,0.504833 -1.4514,1.072769 -0.12621,0.567939 -0.12621,6.49973 -0.18931,10.85392 -0.0631,4.354191 0.82035,9.781151 1.4514,12.747041 0.63104,2.9659 3.15521,9.90736 2.71348,19.68851 -0.44173,9.78115 -1.32519,21.58163 -2.08244,25.43098 -0.75725,3.84936 -0.75725,5.30075 -0.63104,7.82492 0.12621,2.52417 -0.69415,7.5725 -0.63105,8.64527 0.0631,1.07277 1.3883,7.32009 1.13588,12.43153 -0.25242,5.11143 -1.13588,12.36842 -1.38829,16.15467 -0.25242,3.78625 -0.25242,10.34908 -0.25242,11.67427 0,1.32519 0.63104,4.16488 1.64071,5.11144 1.00967,0.94656 11.35875,7.00456 14.26154,9.21321 2.9028,2.20864 9.71805,5.67937 13.37809,7.00456 3.66004,1.32519 11.48496,4.4173 13.50429,5.61627 2.01934,1.19899 5.80559,3.97557 6.87836,5.23765 1.07277,1.26208 2.58727,3.53384 2.9659,4.60661 0.37862,1.07277 0.0631,2.83968 -0.63104,3.40762 -0.69415,0.56794 -1.89313,1.32519 -1.89313,1.32519 0,0 -1.32519,2.27175 -2.77658,2.77658 -1.4514,0.50484 -3.28142,0.69415 -3.28142,0.69415 0,0 -0.69415,2.77658 -2.46106,3.59694 -1.76692,0.82035 -3.59694,0.56794 -3.59694,0.56794 0,0 -1.26209,1.83002 -3.28142,2.77657 -2.01933,0.94657 -4.66971,0.31554 -4.66971,0.31554 0,0 -0.18931,2.90277 -2.83969,3.97555 -2.65037,1.07278 -6.94146,0.31552 -8.64527,-1.38829 -1.70381,-1.70382 -6.75215,-7.19387 -7.5725,-7.6356 -0.82036,-0.44173 -9.15011,-8.89769 -11.86359,-11.35876 -2.71348,-2.46106 -8.39285,-7.38318 -8.83458,-7.95112 -0.44173,-0.56794 -1.5145,-2.27175 -1.4514,-3.09211 0.0631,-0.82035 0.18931,-10.34908 0.63104,-13.12567 0.44173,-2.77658 1.26209,-6.058 1.26209,-7.32008 0,-1.26209 0.12621,-3.15521 -0.0631,-4.92213 -0.18931,-1.76691 -0.56794,-8.89769 -1.26208,-12.1791 -0.69415,-3.28142 -2.58727,-11.67428 -2.58727,-14.57707 0,-2.90279 0.25241,-8.39286 0.31552,-10.72771 0.0631,-2.33486 0.0631,-4.85902 -0.25242,-6.12111 -0.31552,-1.26208 -0.69415,-6.49973 -0.82035,-9.59183 -0.12621,-3.09211 -0.18932,-11.16944 -0.18932,-12.30532 0,-1.13587 -0.6049,-13.01971 -0.6049,-13.01971 -0.47847,-3.19235 -1.38195,-2.63583 -1.38195,-2.63583",
    id: "path2450"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 140.40046,255.81987 c 0,0 4.40647,2.26091 5.92097,4.78508 1.5145,2.52417 1.78409,6.01022 1.78409,6.01022",
    id: "path2452"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 147.15895,252.22741 c 0,0 4.94641,2.18699 6.71333,5.08978 1.76691,2.9028 2.18437,6.20587 2.18437,6.20587",
    id: "path2454"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 155.38415,249.60951 c 0,0 4.01701,1.98686 5.21599,4.88965 1.19898,2.90279 1.51451,4.85902 1.51451,4.85902",
    id: "path2456"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 162.20574,247.41804 c 0,0 3.12721,2.41141 4.3893,4.55695 1.26208,2.14554 1.57761,3.91246 1.57761,3.91246",
    id: "path2458"
  })), /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    href: "#g5587",
    id: "use5589",
    transform: "matrix(-1,0,0,1,203.89142,0)",
    width: "100%",
    height: "100%",
    style: {
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5741",
    transform: "translate(0.98167067,-2.945012)",
    style: {
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 95.846754,33.019831 c 0,0 6.068516,1.784855 8.210336,0.713944 2.14183,-1.070915 4.9976,-1.427885 4.9976,0.713941 0,2.141828 1.02749,5.288015 2.85577,5.711537 2.00718,0.464965 3.08865,2.254143 1.78485,5.354568 -1.56747,3.727425 -2.00347,0.210095 -3.30198,2.677283 0,0 -2.40955,4.819111 -3.83744,6.603967 -1.42788,1.784858 -4.28365,3.301983 -5.71154,3.301983 -2.498797,0 -4.997596,-2.588039 -6.782451,-4.729868 -1.784858,-2.141826 -2.766526,-5.622296 -2.766526,-5.622296 -3.011875,1.41146 -4.997598,-4.640625 -3.569713,-6.068507 1.427884,-1.427885 3.212742,0.892426 3.569712,-0.892429 0.356971,-1.784856 1.338642,-6.336238 4.551382,-7.764123 z",
    id: "path2462"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 89.242788,41.140925 c 0,0 -0.178486,-2.766526 -0.446215,-3.926682 -0.267729,-1.160158 -0.35697,-3.301984 0,-4.015925 0.356971,-0.713944 1.070915,-1.160158 1.427885,-2.141828 0.356971,-0.981671 1.070914,-3.123497 2.052585,-3.48047 0.98167,-0.35697 2.945011,-0.267726 4.015925,-0.624699 1.070914,-0.356971 3.123496,-1.427884 4.729872,-0.713942 1.60637,0.713942 3.03425,1.070915 4.28365,0.892429 1.2494,-0.178487 3.56971,-0.803186 4.19441,0.356971 0.6247,1.160156 1.2494,2.58804 1.78486,3.301981 0.53545,0.713944 1.33864,0.803185 1.42788,2.23107 0.0892,1.427885 0.0892,2.141829 0.0892,3.301984 0,1.160156 -0.35697,4.015925 -0.35697,4.015925",
    id: "path5624"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 93.972654,43.818209 h 3.123499",
    id: "path5626"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 103.8786,43.55048 3.21274,-0.08924",
    id: "path5628"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 98.613279,41.854868 c 0,0 0.803185,0 0.803185,0.535456 0,0 0.267729,0.713941 0.267729,1.784855 0,1.070915 -0.304693,2.036345 -0.393937,2.482557 -0.08924,0.446215 -0.587733,1.176398 -0.409248,1.622612 0.178485,0.446215 0.215448,0.761736 1.643342,0.761736 1.42788,0 2.10486,-0.850979 2.10486,-0.850979",
    id: "path5630"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 98.256308,51.760818 103.16466,51.58233",
    id: "path5632"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 94.954324,40.873195 c 0,0 0.459195,1.280398 1.468864,1.31195 1.009666,0.03155 1.654635,-1.31195 1.654635,-1.31195 v 0 0",
    id: "path6196"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 104.86027,40.605469 c 0,0 0.46061,1.35881 1.62804,1.295707 1.16742,-0.0631 1.5847,-1.384949 1.5847,-1.384949",
    id: "path6198"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer3",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#f2db6b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 2.26772,
      strokeOpacity: 1
    },
    id: "path6529",
    cx: 32.127399,
    cy: 45.870789,
    r: 5.8900242
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer4",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#e01414",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 0.365,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 31.507829,80.723505 -3.079357,-2.821803 -3.140941,3.476498 3.049389,2.731569 -2.86818,2.873056 3.358943,3.26634 2.935311,-3.05997 3.126279,2.86398 3.140942,-3.47649 -3.00482,-2.733954 2.823622,-2.870664 -3.358943,-3.266345 z",
    id: "path11925"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.28b3585fb3c92594ca6203155a098585.svg";
export { ForwardRef as ReactComponent };